import React from 'react';
import classNames from 'classnames';
import { BrandLogo } from '~/components';
import { BrandLogoProps } from '~/components/brand-logo';

interface LogoPageLayoutProps {
    className?: string;
    logoProps?: Omit<BrandLogoProps, 'className'>;
    children: React.ReactNode;
}

const LogoPageLayout: React.FC<LogoPageLayoutProps> = (props) => {
    const { className, logoProps, children } = props;

    return (
        <div className={classNames('fx-logo-page-layout', className)}>
            <BrandLogo className="brand-logo" clickable {...logoProps} />
            {children}
        </div>
    );
};
export default LogoPageLayout;
